/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initRecoveryOtp} from '../api'

export const useMutationInitRecoveryOtp = createReactQueryMutationHook('initRecoveryOtp', initRecoveryOtp)
